import { render, staticRenderFns } from "./UserGroupApplicationTagGroup.vue?vue&type=template&id=d0c013f0&scoped=true&"
import script from "./UserGroupApplicationTagGroup.vue?vue&type=script&lang=ts&"
export * from "./UserGroupApplicationTagGroup.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupApplicationTagGroup.vue?vue&type=style&index=0&id=d0c013f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c013f0",
  null
  
)

export default component.exports